import {
  type CountryCode,
  parsePhoneNumberFromString,
} from 'libphonenumber-js/max';

export const handoffCountries = ['US', 'GB', 'IE'] as const;

export function phoneCountry(
  country: string
): (typeof handoffCountries)[number] {
  return handoffCountries.find((supported) => supported === country) ?? 'IE';
}

export function parseHandoffPhone(value: string, country: CountryCode) {
  const input = value.trim().replace(/^00/, '+');
  if (!input) return undefined;
  const phone = parsePhoneNumberFromString(input, {
    defaultCountry: country,
    extract: false,
  });
  return phone &&
    !phone.ext &&
    (!phone.country || phoneCountry(phone.country) === phone.country)
    ? phone
    : undefined;
}

export function savedHandoffPhone(value: string | null, country: string) {
  const parsed = value
    ? parseHandoffPhone(value, phoneCountry(country))
    : undefined;
  return {
    country: parsed?.country ?? phoneCountry(country),
    number: parsed?.country ? parsed.nationalNumber : (value ?? ''),
  };
}
